const getEnv = (key: string, fallback = ''): string => {
  const value = (import.meta.env as Record<string, string | undefined>)[key];
  return value ?? fallback;
};

export const ENV = {
  API_BASE_URL: getEnv('VITE_API_BASE_URL', '/'),
  GOOGLE_PLACES_API_KEY: getEnv('VITE_GOOGLE_PLACES_API_KEY', ''),
  APP_ENV: getEnv('VITE_APP_ENV', 'development'),
  IS_DEV: getEnv('VITE_APP_ENV', 'development') === 'development',
  SENTRY_DSN: getEnv('VITE_SENTRY_DSN', ''),
  SENTRY_ENVIRONMENT: getEnv('VITE_SENTRY_ENVIRONMENT', ''),
} as const;
